// extracted by mini-css-extract-plugin
module.exports = {"background0":"Background_background0__5E1Te","background1":"Background_background1__ZFBiU","background2":"Background_background2__EJR3q"};